import { useContext, useEffect, useState } from "react";
import { UNSAFE_NavigationContext } from "react-router-dom";

// O react-router 6.2 não tem useBlocker; o history do BrowserRouter tem block(),
// que também liga o aviso nativo do navegador ao fechar ou recarregar a aba.
export const useNavigationBlocker = when => {
    const { navigator } = useContext(UNSAFE_NavigationContext);
    const [transition, setTransition] = useState(null);

    useEffect(() => {
        if (!when || !navigator.block) return;

        const unblock = navigator.block(tx => setTransition({
            retry: () => {
                unblock();
                tx.retry();
            }
        }));

        return unblock;
    }, [when, navigator]);

    return {
        blocked: transition !== null,
        proceed: () => {
            setTransition(null);
            transition?.retry();
        },
        cancel: () => setTransition(null)
    };
};

export default useNavigationBlocker;
